<div
    id="currentStudents-details-container"
    class="currentStudent container"
    *ngIf="currentStudent"
>
    <form (submit)="validate($event)">
        <div class="row">
            <h3>
                {{ currentStudent.firstName }} {{ currentStudent.lastName }}
            </h3>

            <div class="col-md-7">
                <div class="row">
                    <div class="col-md-2">
                        <label for="firstName" class="required">{{
                            'student-list.firstName' | translate
                        }}</label>
                    </div>
                    <div class="col-md-2">
                        <select
                            class="form-control"
                            id="title"
                            required
                            [(ngModel)]="currentStudent.title"
                            name="title"
                            #name="ngModel"
                        >
                            <option value="MRS">M</option>
                            <option value="MS">Mme</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <input
                            type="text"
                            class="form-control"
                            id="firstName"
                            required
                            [(ngModel)]="currentStudent.firstName"
                            name="firstName"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="lastName" class="required">{{
                            'student-list.lastName' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="text"
                            class="form-control"
                            id="lastName"
                            required
                            [(ngModel)]="currentStudent.lastName"
                            name="lastName"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="lastName">{{
                            'student-list.email' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="text"
                            class="form-control"
                            id="email"
                            [(ngModel)]="currentStudent.email"
                            name="email"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="phone">{{
                            'student-list.phone' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="text"
                            class="form-control"
                            id="phone"
                            [(ngModel)]="currentStudent.phone"
                            name="phone"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="separator">
                    &nbsp;
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="address1">{{
                            'student-list.address1' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="text"
                            class="form-control"
                            id="address1"
                            [(ngModel)]="currentStudent.address1"
                            name="address1"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="address2"></label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="text"
                            class="form-control"
                            id="address2"
                            [(ngModel)]="currentStudent.address2"
                            name="address2"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="zipCode">{{
                            'student-list.zipCode' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="number"
                            class="form-control"
                            id="zipCode"
                            [(ngModel)]="currentStudent.zipCode"
                            name="zipCode"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="city">{{
                            'student-list.city' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="text"
                            class="form-control"
                            id="city"
                            [(ngModel)]="currentStudent.city"
                            name="city"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="countryCode">{{
                            'student-list.countryCode' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="text"
                            class="form-control"
                            id="countryCode"
                            [(ngModel)]="currentStudent.countryCode"
                            name="countryCode"
                            #name="ngModel"
                        />
                    </div>
                </div>
                <div class="separator">
                    &nbsp;
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="company" class="required">{{
                            'student-list.company' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            required
                            auto-complete
                            [(ngModel)]="currentStudent.companyName"
                            [source]="searchCompanies.bind(this)"
                            value-property-name="id"
                            [list-formatter]="myListFormatter"
                            [accept-user-input]="false"
                            [min-chars]="1"
                            [max-num-list]="14"
                            display-property-name="name"
                            id="company"
                            class="form-control"
                            (valueChanged)="changeCompany($event)"
                            name="company"
                            autocomplete="off"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="job">{{
                            'student-list.job' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5">
                        <input
                            type="text"
                            class="form-control"
                            id="job"
                            [(ngModel)]="currentStudent.job"
                            name="job"
                            #name="ngModel"
                        />
                    </div>
                </div>
            </div>

            <div class="col-md-5">
                <div class="row">
                    <div class="col-md-2">
                        <label for="internal">{{
                            'student-list.internal' | translate
                        }}</label>
                    </div>
                    <div class="col-md-5" style="padding-top: 7px">
                        <input
                            type="checkbox"
                            id="internal"
                            [(ngModel)]="currentStudent.interne"
                            name="internal"
                            #name="ngModel"
                        />
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div style="margin:0 30px 30px;">
            <button class="btn btn-default" type="submit" name="submit">
                {{ 'student-list.save' | translate }}
            </button>
        </div>

        <div class="plt-display-row col-md-12 plt-b-spaced">
            <h3 style="margin-left: 30px">
                {{ 'student-list.detail.participated' | translate }}
            </h3>
        </div>
        <div class="plt-display-row col-md-12 plt-b-spaced">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th style="width: 50%">
                            {{ 'student-list.detail.training' | translate }}
                        </th>
                        <th style="width: 50%">
                            {{ 'student-list.detail.startDate' | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let session of studentHistory.sessions">
                        <td>
                            <a
                                uiSref="session-detail"
                                [uiParams]="{ id: session.id }"
                            >
                                {{ session.training }}
                            </a>
                        </td>
                        <td>
                            {{ session.startDate | date: 'dd/MM/y' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/student/detail/detail.component.html